import React from 'react';
import Error from '@xingternal/pages-warning';

type ModuleErrorProps = {
  refetch: () => void;
};

const ModuleError = ({ refetch }: ModuleErrorProps) => (
  <div data-testid={'errorContainer'}>
    <Error
      headerText="EP_ERROR_HEADER"
      bodyText="EP_ERROR_BODY"
      buttonText="EP_ERROR_RELOAD_CTA"
      onClick={() => refetch()}
    />
  </div>
);

export default ModuleError;
